import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IResponse } from '../../../../core/interfaces/IResponse';
import { ApiService } from '../../../../core/services/ApiService';
import { ReportKeys } from '../enums/ReportKeys';
import { SafeCountReportTypes } from '../enums/SafeCountReportTypes';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  private readonly _basePath = '/reports';
  private readonly _apiService = inject(ApiService);

  public generateReport(reportKey: ReportKeys, objectId1?: number): Observable<IResponse<{ base64Content: string; }>> {
    return this._apiService.post(`${this._basePath}/generate`, { reportKey, objectId1 });
  }

  public insertCashCountData(
    safeId: number,
    cashCountData: { currency: string; count: number; denomination: number; }[],
    reportType: SafeCountReportTypes
  ): Observable<IResponse<void>> {
    return this._apiService.post(`${this._basePath}/insert-cash-count`, { safeId, cashCountData, reportType });
  }
}
